import * as React from 'react';
import AssetPanel from '../../../panels/assets';
import ProbeConfigPanel from './probeConfig';
import MgmtConfigpanel from './ivmsManagement';
import NtwrkConfigPanel from './networkConfig';
import SaveconfigPanel from './saveconfigPanel';
import DownloadUploadPanel from './downloadUploadConfig';
import SoftwareUpdatePanel from './softwareUpdate';

class State {
    options: any;
    currentIndex: number;
}

interface Props {

}

export default class SystemConfigView extends React.Component<Props, State> {

    componentWillMount() {
        let options = [ 'Probe', 'Management', 'Network Ports', 'Import / Export Configuration', 'Software Update', 'Save Config' ];
        this.setState({
            options: options
        });
    }

    handleOptionsClick(option: string, index: number) {
        this.setState({
            currentIndex: index
        });
    }

    renderRightPanel(selectedOption: string) {
        switch (selectedOption) {
            case 'Probe':
                return <ProbeConfigPanel />;
            case 'Management':
                return <MgmtConfigpanel />;
            case 'Network Ports':
                return <NtwrkConfigPanel />;
            case 'Import / Export Configuration':
                return <DownloadUploadPanel />;
            case 'Software Update':
                return <SoftwareUpdatePanel />;
            case 'Save Config':
                return <SaveconfigPanel />;
            default:
                return <SaveconfigPanel />;
        }
    }

    render() {
        let selectedOption: string = (this.state.options !== undefined && this.state.currentIndex !== undefined)
            ? this.state.options[this.state.currentIndex]
            : null;
        return(
            <div className="view-content" id="systemConfig">
                <div className="pageTitle">
                    <div className="page-title-block">
                        <div className="iq-temp-key-val">
                            <div className="iq-temp-val page-title-text">System Configuration</div>
                        </div>
                    </div>
                </div>
                <div className="view-clientarea column-stretch">
                        <div className="divided-area-main sysConfig-left-panel">
                            <AssetPanel
                                data={this.state.options}
                                onClick={(option: string, index: number) => this.handleOptionsClick(option, index)}
                            />
                        </div>
                        <div className="view-content config-view flow scrollable sysConfig-right-panel" style={{ paddingBottom: 30 }} id="asset-alias">
                            {this.renderRightPanel(selectedOption)}
                        </div>
                </div>
            </div>
        );
    }
}


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/views/config/system/systemConfig.tsx